import styled from "styled-components";
import { useTranslation } from "react-i18next";

const ProductSliderWrapper = styled.div`
  margin: 0 0 50px 0;
  width: 100%;
  background-color: #f7f7f7;
`;
// Title
const Title = styled.p`
  width: 100%;
  margin: auto;
  padding: 50px;
  color: #971b2f;
  font-size: 2.7rem;
  font-weight: 800;
  text-align: center;
  white-space: pre-wrap;
  @media (max-width: 670px) {
    font-size: 2rem;
  }
  @media (max-width: 370px) {
    font-size: 1rem;
  }
`;

// Slider
const SlideWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;
const SlideImageWrapper = styled.div`
  display: flex;
  width: calc(1834px * 2);
  height: 544px;
  animation: slide 40s linear infinite;

  @keyframes slide {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-1834px);
    }
  }
`;
const SlideImage = styled.div`
  width: 1833px;
  height: 544px;
  background-image: url("/main/products/image_roll-scaled.webp");
  background-size: cover;
  background-position: center;
  background-repeat: repeat-x;
`;

export default function ProductSlider() {
  const { t } = useTranslation();
  return (
    <ProductSliderWrapper>
      <Title data-aos="fade-up" data-aos-easing="ease-out" data-aos-delay="100" data-aos-duration="500">
        {t("main.slider.title")}
      </Title>
      <SlideWrapper>
        <SlideImageWrapper>
          <SlideImage />
          <SlideImage />
        </SlideImageWrapper>
      </SlideWrapper>
    </ProductSliderWrapper>
  );
}
